import React from 'react';
import ImageIcon from './ImageIcon';

export default function MainLogo() {
  return (
    <ImageIcon src="/lorikeetbanner.png" />
  )
}